import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import 'img-comparison-slider';

@Component({
  selector: 'app-dojo-before-after',
  standalone: true,
  templateUrl: './dojo-before-after.component.html',
  styleUrls: ['./dojo-before-after.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DojoBeforeAfterComponent {}
